import { useCallback, useRef } from 'react'
import { useFormikContext } from 'formik'
import { useAppDispatch } from 'store'
import { showCPopup } from 'slices/confirmation-popup-slice'

import { useTranslation } from 'react-i18next'

export const useSetFieldValueFromLookup = (setInitialFieldValue: Function) => {
    const { setFieldValue } = useFormikContext()
    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    const _defaultValues = useRef<any>({}) // add dependent values here to trigger useEffect on their change

    const _callback = useCallback((fieldName: string, defValKey:string, currentValue: any, newValue: any, mbox_label: string | undefined, _setFieldValue: Function) => {
        const saveDefValue = () => {
            _defaultValues.current[defValKey] = newValue
        }
        const setDefFieldValue = () => {
            currentValue !== newValue && _setFieldValue(fieldName, newValue)
            saveDefValue()
            //console.log('default value set for field ', fieldName, ' - ', defValKey, ': ', newValue)
        }

        // set value only if default value changed
        if(_defaultValues.current[defValKey] !== newValue) {
            if (mbox_label && newValue !== undefined && currentValue !== undefined &&
                currentValue !== newValue) { // && currentValue !== _defaultValues.current[defValKey]) {
                dispatch(showCPopup({
                    confirmCb: setDefFieldValue,
                    rejectCb: saveDefValue,
                    title: t('global:label.confirmChanges'),
                    description: t(mbox_label),
                }))
            }
            else {
                setDefFieldValue()
            }
        }
    }, [_defaultValues, t, dispatch])

    const setFieldValueFromLookup = useCallback((fieldName: string, defValKey:string, currentValue: any, newValue: any, mbox_label: string | undefined = undefined) => {
        _callback(fieldName, defValKey, currentValue, newValue, mbox_label, setFieldValue)
    }, [setFieldValue, _callback])

    const setInitialFieldValueFromLookup = useCallback((fieldName: string, defValKey:string, currentValue: any, newValue: any, mbox_label: string | undefined = undefined) => {
        _callback(fieldName, defValKey, currentValue, newValue, mbox_label, setInitialFieldValue)
    }, [setInitialFieldValue, _callback])

    return [setFieldValueFromLookup, setInitialFieldValueFromLookup]
}
